import SVG from "../../../Components/SVG";
import { Tooltip } from "react-tooltip";
export default function BackToHome() {
  return (
    <div className="h-full pr-3 flex items-center justify-center border-r border-r-zi-border-light dark:border-r-zi-border-dark">
      <a
        onClick={() => (window.location.href = "https://www.cogitofund.com")}
        data-tooltip-id="backTooltip"
        data-tooltip-content="صفحه خانه"
      >
        <SVG
          name="back"
          classname="size-5 cursor-pointer stroke-zi-blue-dark dark:stroke-white"
        />
      </a>

      <Tooltip
        id="backTooltip"
        place="bottom"
        className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-zi-blue-dark !rounded-lg"
      />
    </div>
  );
}
